import styled from 'styled-components';
import { LoadingSpinner } from '@simplywallst/ui-core';
import CheckIconSVG from '@assets/images/icons/legacy/check.svg';

export const FieldWrapper = styled('div')`
  position: relative;
  margin-bottom: ${(props) => props.theme.x2space * 0.75}rem;
  text-align: left;
`;

export const PasswordRequirement = styled('p')`
  padding-top: ${(props) => props.theme.x2space}rem;
  color: ${({ theme }) => theme.color.mediumGray};
  ${({ theme }) => theme.typography.tiny}
  text-align: left;
  min-height: ${(props) => props.theme.x4space + 0.25}rem;
`;

export const Spinner = styled(LoadingSpinner)`
  margin-top: 12px;
`;

export const Valid = styled(CheckIconSVG)`
  width: 14px;
`;
